import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";

const Terms = () => {
  const sectionRef = useRef(null);
  const { state } = useLocation();
  const refer = state?.refer;

  const scrollToSection = () => {
    sectionRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (refer) {
      scrollToSection();
    }
    // eslint-disable-next-line
  }, []);

  const TermsAndConditions = () => {
    return (
      <div
        className="terms-and-conditions"
        style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}
      >
        <h1>Terms & Conditions</h1>

        <p>
          By downloading or using the app, these terms will automatically apply
          to you. You should make sure therefore that you read them carefully
          before using the app.
        </p>

        <p>
          You’re not allowed to copy, or modify the app, any part of the app, or
          our trademarks in any way. You’re not allowed to attempt to extract
          the source code of the app, and you also shouldn’t try to translate
          the app into other languages, or make derivative versions. The app
          itself, and all the trademarks, copyrights, database rights, and other
          intellectual property rights related to it, still belong to Second
          Innings.
        </p>

        <p>
          Second Innings is committed to ensuring that the app is as useful and
          efficient as possible. For that reason, we reserve the right to make
          changes to the app or to charge for its services, at any time and for
          any reason. We will never charge you for the app or its services
          without making it very clear to you exactly what you’re paying for.
        </p>

        <p>
          The Track Mate app stores and processes personal data that you have
          provided to us, in order to provide our Service. It’s your
          responsibility to keep your phone and access to the app secure. We
          therefore recommend that you do not jailbreak or root your phone.
        </p>

        <h2>Eligibility and Responsibility</h2>
        <p>
          Before you create an account on Track Mate, make sure you are eligible
          to use our Services.
        </p>
        <p>By using our services, you agree that:</p>
        <ul>
          <li>You are at least 18 years old</li>
          <li>
            You are legally qualified to enter a binding contract with Track
            Mate
          </li>
          <li>You do not have more than one account on our Services</li>
          <li>
            You have not previously been removed from our Services by us, unless
            permitted
          </li>
          <li>
            You have not been convicted of serious crimes, including sex or
            violent offenses
          </li>
        </ul>

        <p>You agree that you will not:</p>
        <ul>
          <li>Misrepresent your identity or qualifications</li>
          <li>Use our Services for illegal or harmful purposes</li>
          <li>Harass, stalk, intimidate, defame, or mistreat any person</li>
          <li>Interfere with or damage the Services</li>
          <li>Solicit passwords or personal info from users</li>
          <li>Use another user’s account</li>
          <li>Disclose private or proprietary information without consent</li>
          <li>Use or modify our content without written consent</li>
          <li>Upload malware or compromise the app's security</li>
          <li>Use Track Mate references in unauthorized promotions or tags</li>
          <li>Reverse engineer or decompile the app</li>
          <li>Test or scan vulnerabilities of our systems</li>
          <li>Promote or agree to any activities violating these terms</li>
        </ul>

        <h3 ref={sectionRef}>Invite Terms</h3>
        <ul>
          <li>
            Simply share the app with your friends via social media and
            encourage them to track and organize your daily activities in one
            place.
          </li>
          <li>
            Manage expenses, notes, reminders, and other important records with
            a simple and efficient tracking system designed to help you stay
            organized and productive.
          </li>
          <li>Share the joy and live better.</li>
        </ul>

        <h2 id="referral">All Premium Features</h2>
        <p>Subscribe to access premium features.</p>
        <ul>
          <li>No ads</li>
          <li>Priority support</li>
          <li>Free food menu scan tokens</li>
          <li>All future premium updates</li>
        </ul>

        <p>
          Enjoy uninterrupted access with a flexible subscription. Your
          subscription renews automatically until canceled. Manage/cancel
          subscription anytime through the app or your App Store / Google Play
          account.
        </p>

        <p>
          A subscription gives you access to premium features for the selected
          billing period. It renews automatically unless canceled before the
          next renewal date. Billing is handled securely by the App Store or
          Google Play, and any refund requests are subject to their respective
          policies. By subscribing, you agree to the applicable billing terms
          and acknowledge that refunds are subject to the policies of Apple or
          Google, as applicable.
        </p>

        <p>
          If you've previously purchased a subscription using the same Apple ID
          or Google account, you can restore your access at any time by using
          the Restore button. You will not be charged again for restoring an
          existing purchase. You can manage or cancel your subscription through
          the app or your device's App Store / Google Play account settings.
        </p>

        <p>
          If you cancel, your subscription will remain active until the end of
          the current billing period. If you've completed a purchase but it
          isn't reflected in the app, first try Restore Purchases. If the issue
          persists, please contact our support team with your purchase details.
        </p>

        <p>
          If you have any questions or experience any issues, we're here to
          help.
        </p>

        <h3>Other Services</h3>
        <p>
          The app does use third-party services that declare their own Terms and
          Conditions.
        </p>
        <p>
          <strong>Links to Terms of third-party service providers:</strong>
        </p>
        <ul>
          <li>Google Play Services</li>
          <li>Google Auth</li>
          <li>Google Analytics for Firebase</li>
          <li>Unity Ads</li>
          <li>Google Ads</li>
        </ul>

        <h3>Privacy Notice</h3>
        <p>
          Do not enter any sensitive or confidential information. We are not
          responsible for any consequences resulting from the information you
          provide.
        </p>

        <h2>Limitations of Responsibility</h2>
        <p>
          Certain functions of the app require an internet connection. Whether
          Wi-Fi or mobile data, Second Innings is not responsible if the app
          doesn’t work fully due to poor connection.
        </p>

        <p>
          If you use the app outside your home region, you’re responsible for
          data charges including roaming fees. Make sure you have permission
          from the bill payer to use the app.
        </p>

        <p>
          You must also ensure your device remains charged. Second Innings
          cannot take responsibility if your device is dead and you can’t use
          the Service.
        </p>

        <p>
          We rely on third parties for content accuracy. Second Innings isn’t
          liable for losses due to incorrect or delayed information.
        </p>

        <h2>App Updates and Termination</h2>
        <p>
          We may update the app at any time. If you want to keep using it, you
          must accept these updates. The app is currently available for Android,
          but requirements may change. You agree to stop using the app and
          delete it if we end the service or revoke access.
        </p>

        <h2>Changes to This Terms and Conditions</h2>
        <p>
          We may update our Terms and Conditions from time to time. Please
          review this page periodically. We will notify you of changes by
          posting the updated Terms and Conditions on this page.
        </p>

        <p>
          <strong>Effective date:</strong> 2026-06-15
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have any questions or suggestions about our Terms and
          Conditions, do not hesitate to contact us.
        </p>
      </div>
    );
  };

  return (
    <div>
      <TermsAndConditions />
    </div>
  );
};

export default Terms;
